<template>
  <div>
    <AddBRLModal :industryBranchId="industryBranchId" />
    <UpdateBRLModal :trlDet="trlDet" :industryBranchId="industryBranchId" />
    <MasterLayout>
      <section class="mt-3 full__row_section">
        <div class="row">
          <div class="col-md-12">
            <div
              class="dashboard__card large_card card_padding indus_back_img_lg"
            >
              <div
                class="row make-row-hundred-percent align-items-center justify-content-center"
              >
                <div class="col-md-2">
                  <div
                    class="icon_wrapper yellow centralize icon_div_big"
                    style=""
                  >
                    <img src="@/assets/img/oil-truck.svg" width="" />
                  </div>
                </div>
                <div class="col-md-6 remove-padding-left">
                  <div class="">
                    <h4 class="text-white mobile_text">
                      {{ $t("text.reorderLevel.title") }}
                    </h4>
                  </div>
                  <div class="mt-5">
                    <h5 class="text-white mt-1 mobile_text_para">
                      {{ $t("text.reorderLevel.desc") }}
                    </h5>
                  </div>
                </div>
                <div class="col-md-3 remove-padding-left date__m">
                  <button
                    class="vue_router_link btn btn_theme yellow_text"
                    @click="addBRL"
                  >
                    {{ $t("text.reorderLevel.addRe") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="mt-3 full__row_section">
        <ejs-grid
          v-show="!showLoader"
          ref="dataGrid"
          :created="refreshGrid"
          :allowPaging="true"
          :allowSorting="true"
          :pageSettings="pageSettings"
          :toolbar="toolbar"
          :searchSettings="search"
          :allowExcelExport="true"
          :allowPdfExport="true"
          :toolbarClick="toolbarClick"
          :locale="usedLang"
        >
          <e-columns>
            <e-column width="40" field="index" headerText="#"></e-column>
            <e-column
              field="branch"
              width="180"
              :headerText="$t('text.sales.branch')"
            ></e-column>
            <e-column
              field="product"
              width="180"
              :headerText="$t('text.products.product')"
            ></e-column>
            <e-column
              field="reorderLevel"
              width="180"
              :headerText="$t('text.reorderLevel.title')"
            ></e-column>
            <e-column
              width="100"
              :template="buttonsTemplate"
              :headerText="$t('text.cGrpMgt.action')"
            ></e-column>
          </e-columns>
        </ejs-grid>
        <TableLoader :showLoader="showLoader" />
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Industrial/MasterLayout.vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import backImg from "@/assets/img/pattern_img.png";
import AddBRLModal from "@/components/modals/BranchReorderLevel/addBRLModal";
import UpdateBRLModal from "@/components/modals/BranchReorderLevel/updateBRLModal";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;
export default {
  title: "Reorder Level:: Epump Industrial Portal",
  name: "Reorder_Level",
  components: {
    MasterLayout,
    TableLoader,
    AddBRLModal,
    UpdateBRLModal,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      showLoader: false,
      totalTanks: [],
      volFilled: [],
      totalVolConsumed: 0,
      totalVolFilled: 0,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      trlDet: {},
      backImg,
      industryBranch: null,
      industryBranchId: null,

      pageSettings: { pageSizes: [12, 50, 100, 200], pageCount: 4 },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      buttonsTemplate: function () {
        return {
          template: Vue.component("columnTemplate", {
            template:
              '<div class="btn-group btn-group-sm" role="group">' +
              '<button type="button" class="btn btn-warning" title="Update" @click="updateBRL(data)" >' +
              '<i class="fa fa-edit" aria-hidden="true"></i>' +
              "</button>" +
              '<button type="button" class="btn btn-danger" title="Delete" @click="deleteBRL(data.id)" >' +
              '<i class="fa fa-trash-o" aria-hidden="true"></i>' +
              "</button>" +
              "</div>",
            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              updateBRL: function (trlDet) {
                this.$eventHub.$emit("_updateBRL", trlDet);
              },
              deleteBRL: function (id) {
                this.$eventHub.$emit("_deleteBRL", id);
              },
            },
          }),
        };
      },
    };
  },
  created() {
    this.$eventHub.$on("industryBranch", (industryBranch) => {
      this.industryBranch = industryBranch;
      document.title = `Industry Dashboard - ${industryBranch.name}`;
    });
    this.$eventHub.$on("_updateBRL", (trlDet) => {
      this.updateBRL(trlDet);
    });
    this.$eventHub.$on("_deleteBRL", (id) => {
      this.deleteBRL(id);
    });
    this.$eventHub.$on("getBRL", () => {
      this.getReorderLevels();
    });
  },
  beforeDestroy() {
    this.$eventHub.$off("_updateBRL");
    this.$eventHub.$off("_deleteBRL");
    this.$eventHub.$off("getBRL");
  },
  watch: {
    industryBranch: function (newIndustry, oldIndustry) {
      if (newIndustry.id !== null) {
        this.industryBranchId = newIndustry.id;
        this.getReorderLevels();
      }
    },
  },
  mounted() {
    this.showLoader = true;
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      if (this.$refs.dataGrid) {
        this.$refs.dataGrid.refresh();
      }
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getTotalTanks() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/TotalTankSales/${this.industryBranch.id}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.totalTanks = res.data.totalVolumeConsumed.toFixed(2);
          this.volFilled = res.data.totalVolumeFilled.toFixed(2);
          this.totalVolConsumed = parseFloat(
            res.data.totalVolumeConsumed.toFixed(2)
          );
        });
    },

    getReorderLevels() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Products/ProductReorderLevels/${this.industryBranch.id}`,
          configObject.authConfig()
        )
        .then((response) => {
          let index = 0;
          // response.data.sort((a, b) => new Date(b.date) - new Date(a.date));
          response.data.forEach((element) => {
            element.index = ++index;
          });
          this.showLoader = false;
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },

    addBRL() {
      this.$modal.show("addBRLModal");
    },

    updateBRL(trlDet) {
      this.trlDet = trlDet;
      this.$modal.show("updateBRLModal");
    },

    deleteBRL(id) {
      const remove = confirm(this.$t("text.actionButtons.delete"));
      if (!remove) {
        return;
      }
      this.axios
        .delete(
          `${configObject.apiBaseUrl}/Products/ProductReorderLevels/Delete/${id}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.$toast.open({
            message: this.$t("text.reorderLevel.deleted"),
            type: "success",
            duration: 3000,
          });
          this.getReorderLevels();
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 3000,
          });
        });
    },
  },
};
</script>
